import { call, put } from "redux-saga/effects";
import { preferenceService } from "../services/preferenceService";
import { preferenceConstants } from "../actions/constants/preferenceConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getPreference(action: any): any {
  try {
    const response = yield call(preferenceService.getPreference);
    if (response.success) {
      yield put({ type: preferenceConstants.getPreferenceSuccess, payload: response.resultObject });
    } else {
      yield put({ type: preferenceConstants.getPreferenceFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: preferenceConstants.getPreferenceFailure, payload: error });
  }
}

function* getPreferenceByPhone(action: any): any {
  try {
    const response = yield call(preferenceService.getPreferenceByPhone, action.payload);
    if (response.success) {
      yield put({ type: preferenceConstants.getPreferenceByPhoneSuccess, payload: response.resultObject });
    } else {
      yield put({ type: preferenceConstants.getPreferenceByPhoneFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: preferenceConstants.getPreferenceByPhoneFailure, payload: error });
  }
}

function* savePreference(action: any): any {
  try {
    const response = yield call(preferenceService.savePreference, action.payload);
    if (response.success) {
      yield put({ type: preferenceConstants.savePreferenceSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: preferenceConstants.savePreferenceFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: preferenceConstants.savePreferenceFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const preferenceSaga = {
  getPreference,
  getPreferenceByPhone,
  savePreference,
}
